module.exports = __webpack_public_path__ + "img/play4.406b0a48.png";